'use strict';

import axios from 'axios';
import { listenDOMEvent } from '@jspartials/dom-api-utils';
import { createElement, appendElementContent } from '@jspartials/dom-api-utils';
import { decodeBase64 } from '@jspartials/string-utils';

// Selectors
const selector = {
  stars: '.js-trustpilot-stars',
  input: '#trustpilot',
  widget: '.trustpilot-widget',
  widgetWrapper: '.js-trustpilot-widget-wrapper'
};

// Elements
const element = {
  stars: null,
  input: null,
  widgetWrapper: null
};

// Functions

/**
 * Init elements
 * @returns {void}
 */
const initElements = () => {
  element.stars = document.querySelector(selector.stars) || null;
  element.input = document.querySelector(selector.input) || null;
  element.widgetWrapper =
    document.querySelector(selector.widgetWrapper) || null;
};

/**
 * Init Trustpilot
 * @returns {void}
 */
const initTrustPilot = () => {
  initElements();

  loadTrustPilotLibrary();

  if (element.stars) {
    listenDOMEvent(element.stars, 'click', openReviews);
  }

  if (element.input) {
    listenDOMEvent(element.input, 'change', loadWidgetReviews);
  }
};

/**
 * Load Trustpilot library for widget
 * @returns {void}
 */
const loadTrustPilotLibrary = () => {
  if (!window.Trustpilot) {
    axios
      .post(globalVariables.endpoint.loadTrustpilot)
      .then(function (response) {
        if (response.status === 200) {
          const { data = {} } = response;
          const { isVisible = false } = data;

          if (isVisible) {
            loadTrustpilotScript();
          }
        }
      });
  }
};

/**
 * Load Trustpilot script
 * @returns {void}
 */
const loadTrustpilotScript = () => {
  const head = document.getElementsByTagName('head')[0];
  const script = createElement({
    tag: 'script',
    attributes: [
      {
        name: 'type',
        value: 'text/javascript'
      },
      {
        name: 'async',
        value: true
      },
      {
        name: 'src',
        value: '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js'
      }
    ]
  });

  appendElementContent(head, script);
};

/**
 * Open reviews in accordion
 * @returns {void}
 */
const openReviews = () => {
  if (element.input) {
    element.input.checked = true;
    element.input.dispatchEvent(new Event('change'));
  }
};

/**
 * Load widget reviews
 * @returns {void}
 */
const loadWidgetReviews = () => {
  if (element.input.checked && element.widgetWrapper) {
    const formData = new FormData();
    const productId = element.widgetWrapper?.dataset?.productId || null;

    if (productId) {
      formData.append('productId', productId);

      axios
        .post(globalVariables.endpoint.trustpilotWidgetReviews, formData)
        .then(function (response) {
          if (response.status === 200) {
            const { data = {} } = response;
            const { widgetHtmlEncoded = null } = data;

            if (widgetHtmlEncoded) {
              paintWidgetReviews(widgetHtmlEncoded);
            }
          }
        })
        .catch((error) => {
          console.log('ERROR!');
          console.error(error);
        });
    }
  }
};

const paintWidgetReviews = (htmlEncoded) => {
  if (element.widgetWrapper && htmlEncoded) {
    const widgetHtml = decodeBase64(htmlEncoded);

    element.widgetWrapper.innerHTML = widgetHtml;
    showReviews();
  }
};

/**
 * Show reviews
 * @returns {void}
 */
const showReviews = () => {
  const widget = document.querySelector(selector.widget) || null;

  if (widget && window.Trustpilot) {
    window.Trustpilot.loadFromElement(widget);
  }
};

export { initTrustPilot };
